exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1hjln{white-space:nowrap;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:6px 6px 6px 0;height:32px;padding:0 8px;font-size:12px;color:#333;min-width:90px;border-radius:2px;border:1px solid #ffd906;cursor:pointer}._1hjln>svg{margin-right:8px}._1hjln:hover{background-color:#ffd906;-webkit-transition:.3s;-o-transition:.3s;transition:.3s}._1hjln:last-child{margin-right:0}._1SOx4{border:1px solid #c4c4c4;border-radius:2px;pointer-events:none;color:#c4c4c4}._1SOx4 path{fill:#c4c4c4}", ""]);

// exports
exports.locals = {
	"tag": "_1hjln",
	"disabled": "_1SOx4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/UI/TagButton/TagButton.css
// module id = 1315
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46